import {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoServiceType} from './doppe-auto-service-type';

export const DoppeServicesExternalDataSourceType = {
    LatestWixServices: 'LatestWixServices',
    LatestHoppServices: 'LatestHoppServices'
} as const;

export type DoppeServicesExternalDataSourceType = Values<typeof DoppeServicesExternalDataSourceType>;

export type DoppeServicesExternalDataSource =
    | {
    type: typeof DoppeServicesExternalDataSourceType.LatestWixServices;
} | {
    type: typeof DoppeServicesExternalDataSourceType.LatestHoppServices;
};

export function doppeServicesExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeServicesExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeServicesExternalDataSourceType.LatestWixServices: {
            return {businessEntity: DoppeBusinessEntity.WixAutoServicesList, id: DoppeAutoServiceType.Latest}
        }
        case DoppeServicesExternalDataSourceType.LatestHoppServices: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoServicesList, id: DoppeAutoServiceType.Latest}
        }
    }
}